
import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { calculateUpdatedTime } from 'src/app/attendance/shift-time';
import { DataSharingService } from 'src/app/attendance/data-sharing.service';
import { AttendanceService } from 'src/app/shared/services/attendanceservices/attendance.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { FormsModule, NgForm } from '@angular/forms';
import Swal from 'sweetalert2';
import { SharedDataOfUserAttendanceService } from 'src/app/shared-data-of-user-attendance.service';
import { CommonModule } from '@angular/common';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
@Component({
  selector: 'app-user-attendance-type',
  templateUrl: './user-attendance-type.component.html',
  styleUrl: './user-attendance-type.component.css',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, CKEditorModule]
})
export class UserAttendanceTypeComponent implements OnInit {

  @Input() type: any;
  @Input() paidLeaves: any[] = [];
  @Input() unpaidLeaves: any[] = [];
  @Input() pendingLeaves: any[] = [];
  @Input() shortLeaves: any[] = [];

  public userid: any;
  public user: any = [];
  public data: any = 'red';
  public checkin: any = ''
  public checkout: any = ''
  public backgroundColor: any;
  public titleColor: any;
  public titleColortwo: any;
  public titleColorthree: any;
  public attendanceType: any[] = [];
  public trClass: any

  public noOfRequest: any;
  public status: any;
  getdata: any;
  absentForLeaveBtnShow = false;

  attendanceRequest: any;
  attendance_id: any;
  id: any;
  showSpinner: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  workingHours: any;
  shiftStartTime: any;
  shiftEndTime: any;
  totalWorkingHours: any;
  latestShiftstarttime: any;
  latestShiftendtime: any;
  latestShifthours: any;
  latestShiftoffday: any;
  offday: any;
  text: any;
  public Editor = ClassicEditor;

  selectedRadio = 'checkin';
  public _user_id: any;
  public _attendance_id: any;
  public _check_in: any;
  public _check_out: any;
  public _working_hours: any;
  public _overtime: any;
  public _type: any;
  public _date: any;
  public _reason: any = '';
  public _status: any;
  public old_value: any = '';
  check_in: any
  old_valueChickin: any;

  public getRowToModal_user_id: any;
  public getRowToModal_id: any;
  public getRowToModal_date: any;
  public getRowToModal_check_in: any;
  public getRowToModal_check_out: any;
  public getRowToModal_total_hours: any;
  public getRowToModal_overtime: any;
  date2: any;
  overtime_data_startTime: any;
  overtime_data_endTime: any;
  source: any;
  salaryCheck: any;
  hasTracker = false;
  constructor(
    private attendanceService: AttendanceService,
    public dashboardService: DashboardService,
    private dataSharingService: DataSharingService,
    private sharedmode: SharedModeService,
    private router: Router,
    private sharedDataOfUserAttendanceService: SharedDataOfUserAttendanceService

  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    // this.user_detail();
  }

  ngOnInit(): void {
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;

    });




    this.getAttandaceDetails();
    this.sharedDataOfUserAttendanceService.rowData$.subscribe(data => {
      if (data) {
        this.getRowToModal_user_id = data.user_id;
        this.getRowToModal_id = data.id;
        this.getRowToModal_date = data.date;
        this.getRowToModal_check_in = data.check_in;
        this.getRowToModal_check_out = data.check_out;
        this.getRowToModal_total_hours = data.total_hours;
        this.getRowToModal_overtime = data.overtime;
        this.overtime_data_startTime = data.start_time_overtime;
        this.overtime_data_endTime = data.end_time_overtime;
        if (this.overtime_data_startTime !== undefined && this.overtime_data_startTime !== null && this.overtime_data_endTime !== undefined && this.overtime_data_endTime !== null) {
          this.calculateWorkingHours();
        }
        else {
          this._overtime = null;
        }
      }
    });

  }



  isOverTime() {
    if (this.type?.data[0]?.overtime != 0 && this.type.data[0]?.overtime > 0) {
      return true
    } else {
      return false
    }
  }


  trimText() {
    this._reason = this._reason.replace(/\s+/g, ' ').trim();
  }


  getAttendanceData() {

    this.attendanceService.getrequest().then((value) => {
      this.attendanceRequest = value.data
    });


  }


  btnok(id: any) {
    this.router.navigate(['/user-attendance-view', id]);
  }



  isWeekend(data: any): boolean {
    const date = data?.date;
    if (!date) return false;
    const dateObj = new Date(date);
    const dayOfWeek = dateObj.getDay();
    const off_day = data?.off_day == 1 || data?.usershittime?.off_day == '1' || data?.usershittime?.off_day == 1;
    const noCheckIn = !data?.check_in;
    const noCheckOut = !data?.check_out;
    return noCheckIn && noCheckOut && (dayOfWeek === 0 || dayOfWeek === 6 || off_day);
  }

  Holidays(data: any) {
    const date = data?.date;
    if (!date) return undefined;
    const index = this.dashboardService.otherOffDays.indexOf(date);
    if (index > -1) {
      return this.dashboardService.otherOffDaysvalue[index];
    }
    return undefined;
  }

  isCheckInLate(checkIn: string, shiftStart: string): boolean {
    if (!checkIn || !shiftStart) return false;
    const normalizedCheckIn = checkIn.replace('.', ':');
    const [checkH, checkM] = normalizedCheckIn.split(':').map(Number);
    const [shiftH, shiftM] = shiftStart.split(':').map(Number);
    const checkMinutes = checkH * 60 + checkM;
    let shiftMinutes = shiftH * 60 + shiftM;
    // Keep the 75 minutes grace period as per existing logic, or should I reduce it? 
    // The user didn't ask to change the grace period, but 75 mins is a lot.
    // However, 10:16 > 09:00 + 75m (10:15), so it works for the reported case.
    shiftMinutes += 75;
    return checkMinutes > shiftMinutes;
  }

  isShiftPassed(shiftTime: string, shiftDate: string): boolean {
    if (!shiftTime) return false;
    const now = new Date();
    const [year, month, day] = shiftDate.split(/[/-]/).map(Number);
    const shiftDateObj = new Date(year, month - 1, day);
    const [hours, minutes] = shiftTime.split(':').map(Number);
    shiftDateObj.setHours(hours, minutes, 0, 0);
    return now > shiftDateObj;
  }

  isBothConditionsGreen(data: any): boolean {
    let starttime = data?.shift_start_time ?? data?.usershittime?.start_time;
    if (!starttime) {
      starttime = '00:00';
    } else {
      // Assuming calculateUpdatedTime is available in this component's scope.
      // If it's imported, it will work. Otherwise, it might be an issue.
      // Based on the old code, it used calculateUpdatedTime.
      if (typeof calculateUpdatedTime !== "undefined") {
        starttime = calculateUpdatedTime(starttime);
      }
    }
    let checkInCondition = false;
    if (data?.check_in) {
      checkInCondition = (data.check_in < starttime);
    }

    let totalHoursCondition = false;
    const workingHours = Number(data?.total_hours ?? 0);
    const expectedHours = Number(data?.total_working_hours ?? data?.usershittime?.total_working_hours ?? 0);

    if (expectedHours > 0) {
      totalHoursCondition = (workingHours >= expectedHours);
    } else {
      totalHoursCondition = false;
    }

    const checkOutCondition = true;

    return checkInCondition && checkOutCondition && totalHoursCondition;
  }

  trackerCheck(data: any) {
    if (data?.data?.[0]?.source == 'Tracker') {
      const workingHours = Number(data?.total_hours ?? 0);
      const expectedHours = Number(data?.data?.[0]?.total_working_hours ?? 0);
      return workingHours > 0 && workingHours < expectedHours;
    }
    return false;
  }

  getStatus(data: any): string {
    const record = data?.data?.[0];
    if (!record) return "No Data";

    if (record?.user?.salary_type == 'hourly') {
      if ((!record.check_in || record.check_in === "") && (!record.check_out || record.check_out === "")) {
        return "Skip Day";
      } else {
        return "All Good";
      }
    }

    const joiningDateStr = record?.user?.joining_date;
    const recordDate = new Date(record.date.replace(/\//g, "-"));
    if (joiningDateStr) {
      const joiningDate = new Date(joiningDateStr);
      if (recordDate < joiningDate) {
        return "Pre Joining";
      }
    }

    const lastWorkingDateStr = record?.user?.last_working_date;
    if (lastWorkingDateStr) {
      const lastWorkingDate = new Date(lastWorkingDateStr);
      if (recordDate > lastWorkingDate) return "Post Leaving";
    }

    const holidayTitle = this.Holidays(record);
    if (holidayTitle !== undefined && holidayTitle) {
      return holidayTitle;
    }

    if (record.off_day === 1 || record?.usershittime?.off_day == '1' || record?.usershittime?.off_day == 1) {
      return "Off Day";
    }

    const leaveCheckDate = record.date.replace(new RegExp('/', 'g'), '-');
    const shortLeaveOnDate = this.shortLeaves.find(sl => sl.date === leaveCheckDate && sl.status === 'approved');

    if (this.paidLeaves.includes(leaveCheckDate)) {
      return "Paid Leave";
    }
    if (this.unpaidLeaves.includes(leaveCheckDate)) {
      return "UnPaid Leave";
    }

    if (record.leave_id != null && record.leave_type == 'paid' && (record.leave_status === 'approved' || record.leave_status === 'recommended')) {
      return "Paid Leave";
    }
    if (record.leave_id != null && record.leave_type == 'unpaid' && (record.leave_status === 'approved' || record.leave_status === 'recommended')) {
      return "UnPaid Leave";
    }

    if ((!record.check_in || record.check_in === "") && (!record.check_out || record.check_out === "")) {
      return "Absent";
    }

    if (this.isWeekend(record)) {
      return "Weekend";
    }

    const shift_start = record.shift_start_time ?? record?.usershittime?.start_time;
    const shift_end = record.shift_end_time ?? record?.usershittime?.end_time;

    if (!shortLeaveOnDate) {
      if (
        record.check_in &&
        record.check_in !== "" &&
        shift_start &&
        this.isCheckInLate(record.check_in, shift_start)
      ) {
        return "Punch In Late";
      }

      if (
        record.check_in &&
        record.check_in !== "" &&
        (!record.check_out || record.check_out === "") &&
        shift_end &&
        this.isShiftPassed(shift_end, record.date)
      ) {
        return "Punch Out Mis.";
      }

      if (
        (!record.check_in || record.check_in === "") &&
        (record.check_out && record.check_out !== "")
      ) {
        return "Punch In Mis.";
      }
    }

    const totalHours = Number(data.total_hours ?? record.total_hours ?? 0);
    let expectedHours = Number(record.total_working_hours ?? record?.usershittime?.total_working_hours ?? 0);

    // --------------- just Ramzan ------------------
    const ramzanDateStart = new Date("2026/02/19");
    const ramzanDateEnd = new Date("2026/03/20");
    if (recordDate > ramzanDateStart && recordDate < ramzanDateEnd && expectedHours) {
      if (expectedHours > 7) expectedHours = 7.0;
    }
    // --------------- just Ramzan ------------------

    // Deduct Short Leave Hours if exists for this date
    if (shortLeaveOnDate) {
      expectedHours -= shortLeaveOnDate.hours;
    }

    if (expectedHours > 0 && totalHours > 0 && totalHours + 0.05 < expectedHours) {
      return "Short Hours";
    }

    if (this.isBothConditionsGreen(record)) {
      return "All Good";
    }

    if (!this.trackerCheck(data) && record.check_out != null && record.check_in != null) {
      return "All Good";
    }

    return "";
  }

  getStatuses(data: any): string[] {
    const record = data?.data?.[0];
    const statuses: string[] = [];
    if (!record) return ["No Data"];
    const primaryStatus = this.getStatus(data);
    if (primaryStatus) {
      statuses.push(primaryStatus);
    }

    const isAbsent = (!record.check_in || record.check_in === "") && (!record.check_out || record.check_out === "");
    const leaveCheckDate = record.date.replace(new RegExp('/', 'g'), '-');
    const hasPendingLeave = this.pendingLeaves.includes(leaveCheckDate) || (record.leave_id != null && (record.leave_status === 'pending' || record.leave_status === 'applied'));

    if ((!record.check_in || record.check_in === "") && (record.check_out && record.check_out !== "") && primaryStatus !== "Absent" && primaryStatus !== "Punch In Mis.") {
      statuses.push("Punch In Missing");
    }

    if (isAbsent && hasPendingLeave) {
      if (!statuses.includes("Applied Leave")) {
        statuses.push("Applied Leave");
      }
    }

    const shortLeaveRecord = this.shortLeaves.find(sl => sl.date === leaveCheckDate);
    if (shortLeaveRecord) {
      if (shortLeaveRecord.status === 'approved') {
        const typeStr = shortLeaveRecord.payment_status === 'unpaid' ? "Short UnPaid Leave" : "Short Paid Leave";
        statuses.push(typeStr);
      } else if (shortLeaveRecord.status === 'pending' || shortLeaveRecord.status === 'applied') {
        if (!statuses.includes("Applied Leave")) {
          statuses.push("Applied Leave");
        }
      }
    }

    return statuses;
  }

  mapStatusToBadge(status: string) {
    let trClass = "";
    const att_type: Record<string, string> = {};

    switch (status) {
      case "Pre Joining":
      case "Post Leaving":
      case "Off Day":
      case "Weekend":
      case "Skip Day":
        trClass = status === "Skip Day" ? "skip" : "day-off";
        att_type["title"] = status === "Off Day" ? "Day Off" : status;
        att_type["srcImg"] = status === "Skip Day" ? "/assets/attendance/skip.svg" : "/assets/attendance/dayoff.svg";
        att_type["spanClass"] = status === "Skip Day" ? "skip-badge" : "day-off-badge";
        break;
      case "Paid Leave":
        trClass = "paid-leave";
        att_type["title"] = "Paid Leave";
        att_type["srcImg"] = "/assets/attendance/shield-dollar.svg";
        att_type["spanClass"] = "paid-leave-badge";
        break;
      case "UnPaid Leave":
        trClass = "paid-leave";
        att_type["title"] = "UnPaid Leave";
        att_type["srcImg"] = "/assets/attendance/shield-dollar.svg";
        att_type["spanClass"] = "paid-leave-badge";
        break;
      case "Applied Leave":
        trClass = "pending-leave";
        att_type["title"] = "Leave Applied";
        att_type["srcImg"] = "/assets/attendance/shield-dollar.svg";
        att_type["spanClass"] = "pending-leave-badge";
        break;
      case "Absent":
        trClass = "absent";
        att_type["title"] = "Absent";
        att_type["srcImg"] = "/assets/attendance/xcross.svg";
        att_type["spanClass"] = "absent-badge";
        break;
      case "Punch In Mis.":
      case "Punch In Missing":
        trClass = "late-punchin";
        att_type["title"] = "Punch In Missing";
        att_type["srcImg"] = "/assets/attendance/latepunchin.svg";
        att_type["spanClass"] = "late-punchin-badge";
        break;
      case "Punch Out Mis.":
        trClass = "late-punchin";
        att_type["title"] = "Punch Out Missing";
        att_type["srcImg"] = "/assets/attendance/latepunchin.svg";
        att_type["spanClass"] = "Punch-Out-Missing";
        break;
      case "Short Hours":
        trClass = "short-hours";
        att_type["title"] = "Short Hours";
        att_type["srcImg"] = "/assets/attendance/alarm-clock-minus.svg";
        att_type["spanClass"] = "short-hours-badge";
        break;
      case "Punch In Late":
      case "Late Punch In":
        trClass = "late-punchin";
        att_type["title"] = "Late Punch In";
        att_type["srcImg"] = "/assets/attendance/latepunchin.svg";
        att_type["spanClass"] = "late-punchin-badge";
        break;
      case "Short Leave":
      case "Short Paid Leave":
      case "Short UnPaid Leave":
        trClass = "paid-leave";
        att_type["title"] = status;
        att_type["srcImg"] = "/assets/attendance/shield-dollar.svg";
        att_type["spanClass"] = "paid-leave-badge";
        break;
      case "All Good":
        trClass = "all-good";
        att_type["title"] = "All Good";
        att_type["srcImg"] = "/assets/attendance/check.svg";
        att_type["spanClass"] = "all-good-badge";
        break;
      case "No Data":
      case "":
        break;
      default:
        trClass = "day-off";
        att_type["title"] = status;
        att_type["srcImg"] = "/assets/attendance/dayoff.svg";
        att_type["spanClass"] = "day-off-badge";
        break;
    }
    return { trClass, att_type };
  }

  getAttandaceDetails() {
    this.attendanceType = [];
    this.trClass = "";
    this.absentForLeaveBtnShow = false;
       const attendance = this.type?.data[0];
    if (this.type?.data && this.type?.data?.length > 0) {

      this.checkin = attendance?.check_in;
      this.id = attendance?.id;
      this.userid = attendance?.user_id;
      this.checkout = attendance?.check_out;
      this.noOfRequest = attendance?.no_of_request ?? '';
      this.status = attendance?.request_status ?? '';
      this.workingHours = parseFloat(this.type?.total_hours.toFixed(2));;
      
      this.shiftStartTime = attendance?.shift_start_time;
      this.shiftEndTime = attendance?.shift_end_time;
      this.totalWorkingHours = attendance?.total_working_hours;
      this.latestShiftoffday = attendance?.off_day;
      this.source = attendance?.source;
      this.hasTracker = this.type.data.some((item: any) => item.source === 'Tracker');
      this.salaryCheck = attendance?.user?.salary_type;
    } else {
      console.warn('No attendance data available.');
      return;
    }

    const statuses = this.getStatuses(this.type);

    const leaveCheck = this.type.data[0].date.replace(/\//g, '-');

    const hasLeaveApplied =
      this.pendingLeaves.includes(leaveCheck) ||
      statuses.includes("Applied Leave");

    if (
      (statuses.includes("Absent") || statuses.includes("Skip Day")) &&
      !hasLeaveApplied
    ) {
      this.absentForLeaveBtnShow = true;
    }

    if (statuses.length === 0 || (statuses.length === 1 && statuses[0] === "No Data")) {
      const { trClass, att_type } = this.mapStatusToBadge("All Good");
      this.attendanceType.push(att_type);
      this.trClass = trClass;
    } else {
      statuses.forEach((status, index) => {
        const { trClass, att_type } = this.mapStatusToBadge(status);
        if (att_type["title"]) {
          this.attendanceType.push(att_type);
        }
        if (index === 0) {
          this.trClass = trClass;
        } else if (status === "Applied Leave") {
          this.trClass += this.trClass ? " pending-leave" : "pending-leave";
        }
      });
    }

    const leaveCheckDate = this.type.data[0].date.replace(new RegExp('/', 'g'), '-');
    if (this.pendingLeaves.includes(leaveCheckDate) && !statuses.includes("Applied Leave")) {
      const alreadyHasLeaveBadge = this.attendanceType.some(
        t => t.title === "Paid Leave" || t.title === "Un Paid Leave" || t.title === "Leave Applied" || t.title === "Short Paid Leave" || t.title === "Short UnPaid Leave"
      );
      if (!alreadyHasLeaveBadge) {
        const pendingLeaveType: Record<string, string> = {};
        pendingLeaveType["title"] = "Leave Applied";
        pendingLeaveType["srcImg"] = "/assets/attendance/shield-dollar.svg";
        pendingLeaveType["spanClass"] = "pending-leave-badge";
        this.attendanceType.push(pendingLeaveType);
        this.trClass += this.trClass ? " pending-leave" : "pending-leave";
      }
    }

    
  }
  getAttendanceColour(data: any) {

    if (data == 'Check In Late') {
      return '#EB5F8C';
    }
    if (data == 'Check In Miss') {
      return '#FB908F';
    }
    if (data == 'Check Out Miss') {
      return '#175F87';
    }
    if (data == 'Leave') {
      return '#FD7171';
    }
    if (data == 'Short Leave') {
      return '#478AD1';
    }
    if (data == 'Normal') {
      return 'white';
    }
    if (data == 'Absent') {
      return '#DD011D';
    }

    if (data == 'Weekend') {
      return '#2180FF';
    }

    if (data == 'Short Hours') {
      return '#E6991C';
    }

    return '';
  }

  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }




  mydata(user_id: any, id: any, date: any, check_in: any, check_out: any, total_hours: any, overtime: any, shift_start_time: any, shift_end_time: any, total_working_hours: any) {
    // working here
    let start_time_overtime;
    let end_time_overtime;
    if (check_out > shift_end_time) {
      start_time_overtime = shift_end_time;
      end_time_overtime = check_out;
    }

    const rowData = { user_id, id, date, check_in, check_out, total_hours, overtime, start_time_overtime, end_time_overtime };
    this.sharedDataOfUserAttendanceService.setRowData(rowData);
  }

  onSubmit(f: NgForm) {
    if (f.value.correction !== null && f.value.correction !== undefined && f.value.correction === "checkin") {
      this.old_value = this.getRowToModal_check_in;
      this._check_in = f.value.checkin;
      this._reason = f.value.reason;
      this._user_id = this.getRowToModal_user_id;
      this._attendance_id = this.getRowToModal_id;
      this._check_out = '';
      this._working_hours = '';
      this._overtime = '';
      this._type = 'check_in';
      this._date = this.getRowToModal_date;
      this._status = 'pending';


    }
    else if (f.value.correction !== null && f.value.correction !== undefined && f.value.correction === "checkout") {
      this.old_value = this.getRowToModal_check_out;
      this.date2 = this.getRowToModal_date;
      this.old_valueChickin = this.getRowToModal_check_in;
      //Combine date and time checkout
      this._check_out = f.value.checkout;
      const combinedchecoutString = `${this.date2} ${this._check_out}`;
      const combinedcheckout = new Date(combinedchecoutString);
      // Format the date
      const formattedCheckOut = combinedcheckout;
      this._check_out = f.value.checkout;
      this._reason = f.value.reason;
      this._user_id = this.getRowToModal_user_id;
      this._attendance_id = this.getRowToModal_id;
      this._check_in = '';
      // Correct total Hours Calculation
      const currentDate = formattedCheckOut; //#NEED TO CHANGE CHECKOUT - tAGETED
      const mn = currentDate.getMonth() + 1
      const month = (mn < 10) ? `0${mn}` : (mn)
      const checkOutTime = `${currentDate.getHours()}:${currentDate.getMinutes() < 10 ? "0" + currentDate.getMinutes() : currentDate.getMinutes()}`;
      const checkOutDate = `${currentDate.getFullYear()}/${month}/${currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate()}`;
      let totalHours = 0;
      if (this.old_valueChickin != "" && this.old_valueChickin != null) {
        totalHours = Math.abs(new Date(`${checkOutDate} ${checkOutTime}`).getTime() - new Date(`${this.date2} ${this.old_valueChickin}`).getTime()) / 36e5;
        totalHours = totalHours < 0 ? totalHours * (-1) : totalHours;
      }

      this._working_hours = totalHours.toFixed(2);
      this._overtime = '';
      this._type = 'check_out';
      this._date = this.getRowToModal_date; //this.sharedData.date;
      this._status = 'pending';
    }
    else if (f.value.correction !== null && f.value.correction !== undefined && f.value.correction === "overtime") {
      this.old_value = this.getRowToModal_overtime; //this.sharedData.overtime;
      this._overtime;
      this._reason = f.value.reason;
      this._user_id = this.getRowToModal_user_id; //this.sharedData.user_id;
      this._attendance_id = this.getRowToModal_id;  //this.sharedData.attendance_id;
      this._check_in = this.overtime_data_startTime ?? '';
      this._check_out = this.overtime_data_endTime ?? '';
      this._working_hours = '';
      this._type = 'overtime';
      this._date = this.getRowToModal_date; //this.sharedData.date;
      this._status = 'pending';
    }

    // muneeb

    this.attendanceService

      .attendanceCorrection(
        this._user_id,
        this._attendance_id,
        this._check_in,
        this._check_out,
        this._working_hours,
        this._overtime,
        this._type,
        this._date,
        this._reason,
        this._status,
        this.old_value
      )


      .then((value) => {
        // this.showSpinner = false;

        if (value.success == true) {
          // ($('#attendanceModal') as any).modal('hide');


          ($('#attendanceModal') as any).modal('hide'); // Hide modal
          $('.modal-backdrop').remove(); // Remove lingering backdrop
          $('body').removeClass('modal-open'); // Remove body class that prevents scrolling

          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Applied Successfully',
            showConfirmButton: false,
            timer: 1500,
          });
          setTimeout(() => {
            window.location.reload(); // Refresh page
          }, 300);

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
      });



  }

  // calculation of working hours
  calculateWorkingHours() {
    if (this.overtime_data_startTime && this.overtime_data_endTime) {
      const startTime = new Date(`1970-01-01T${this.overtime_data_startTime}`);
      const endTime = new Date(`1970-01-01T${this.overtime_data_endTime}`);

      // If end time is before start time, assume it's the next day
      if (endTime <= startTime) {
        endTime.setDate(endTime.getDate() + 1);
      }

      const diff = (endTime.getTime() - startTime.getTime()) / (1000 * 60 * 60); // Difference in hours
      this._overtime = diff.toFixed(2); // Set total working hours with 2 decimal places
    } else {
      this._overtime = null; // Clear total working hours if times are not set
    }
  }

}
